module.exports = __webpack_public_path__ + "img/2.a9ae6405.jpg";